import {styled} from '@mui/material'
import {useParams} from 'react-router-dom'
import {useEffect, useRef, useState} from 'react'
import {
    useCreateClientNoteMutation,
    useDeleteClientNoteMutation,
    useGetClientNotesQuery,
    useSaveClientNoteMutation,
} from 'store/Store'
import Note from './Note'
import {useForm} from 'react-hook-form'
import NoteInput from './NoteInput'

const ClientNotes = () => {
    const {clientId} = useParams()
    const {data: notes} = useGetClientNotesQuery(clientId)

    const [doCreateNote] = useCreateClientNoteMutation()
    const [doDelete] = useDeleteClientNoteMutation()
    const [doSave] = useSaveClientNoteMutation()

    const [showInput, setShowInput] = useState(false)
    const [editNoteId, setEditNoteId] = useState(null)

    const {
        control,
        formState: {errors: formErrors},
        handleSubmit,
        reset,
        setValue,
    } = useForm()

    const onSubmit = async (submittedData) => {
        if (editNoteId) {
            console.log('edit note body', {
                PlannerClientKey: clientId,
                ClientNoteKey: editNoteId,
                ...submittedData,
            })
            doSave({
                PlannerClientKey: clientId,
                ClientNoteKey: editNoteId,
                ...submittedData,
            })
            setEditNoteId(null)
        } else {
            doCreateNote({
                PlannerClientKey: clientId,
                ...submittedData,
            })
            setShowInput(false)
        }

        reset('Note')
    }

    const submit = handleSubmit(onSubmit)

    const inputRef = useRef(null)

    const onClickAdd = () => {
        setShowInput(true)
    }

    const onDelete = (note) => {
        doDelete(note)
    }

    const onEdit = (note) => {
        console.log({note})
        setEditNoteId(note.ClientNoteKey)
        setValue('Note', note.Note)
    }

    useEffect(() => {
        if (showInput) {
            inputRef?.current?.focus()
        }
    }, [inputRef, showInput])

    return (
        <Container>
            {notes?.map((note, index) => {
                return editNoteId === note.ClientNoteKey ? (
                    <NoteInput
                        inputRef={inputRef}
                        control={control}
                        formErrors={formErrors}
                        onClose={() => setEditNoteId(null)}
                        submit={submit}
                    />
                ) : (
                    <Note
                        key={note.ClientNoteKey}
                        note={note}
                        onClickAdd={onClickAdd}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        showAddButton={notes.length - 1 === index && !showInput}
                    />
                )
            })}

            {showInput && (
                <NoteInput
                    inputRef={inputRef}
                    control={control}
                    formErrors={formErrors}
                    onClose={() => setShowInput(false)}
                    submit={submit}
                />
            )}
        </Container>
    )
}

export default ClientNotes

const Container = styled('div')`
    display: flex;
    flex-direction: column;
    padding-block: 48px;
    gap: 12px;
    height: 100%;
`
